import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import AbstractDocument from '../Abstract/AbstractDocument'

// Phase 2 of the CMS overhaul — single-doc editor for `type: 'page'` filters
// (the 14 static-page metadata records seeded by phase2.seed-pages.script).
// Pages are not hierarchical and don't carry media on their own, so we hide
// the irrelevant filter fields. Status (online/offline/draft/scheduled) is
// shown so editors can take a page offline without deleting it.
// Homepage-specific fields are hidden here and exposed only on
// /pages/homepage (Homepage.jsx).
const Page = function () {
  return (
    <AbstractDocument
      singleCollectionName="Page"
      notToShow={[
        'ancestorIds',
        'parentId',
        'type',
        'featured',
        'coverPhoto',
        'images',
        'videos',
        ...SLIDE_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
    />
  )
}
export default Page
